import { useUserContext } from "../../../../contexts/UserContext";
import { LandingPageOptions, RecordPageProps } from "../../../../types";
import { Content, CONTENT_TYPES } from "@cdkglobal/radial";
import { fetchRowDataListWithUpdatedOptions } from "../../helpers";
import {
  SetupsDashboardNavHeaderContainer,
  SetupDescriptionContent,
} from "../../../../utils/styled";
import { DynamicIdSelector } from "./DynamicIdSelector";
import { useMutation } from "@tanstack/react-query";

export function SetupsDashboardNavHeader({
  rowDataReducerState,
  dispatch,
}: Readonly<RecordPageProps>): JSX.Element {
  const {
    setupListNavInfoByDepartment,
    iamUserState,
    setTableTitleInfo,
    setupBaseRequestInfo,
    headerLabel,
    evaluatedResults,
    setEvaluatedResults,
  } = useUserContext();
  const { schema } = rowDataReducerState;
  const setupDescription = rowDataReducerState.schema?.description || null;

  const handleLandingPageOptionsUpdate = async (
    landingPageOptions: LandingPageOptions,
  ) => {
    return fetchRowDataListWithUpdatedOptions({
      landingPageOptions,
      setupBaseRequestInfo,
      iamUserState,
      setupListNavInfoByDepartment,
      setTableTitleInfo,
      schema,
      evaluatedResults,
      setEvaluatedResults,
      dispatch,
      headerLabel,
    });
  };

  const { mutate: refetchTableDataWithUpdatedOptions } = useMutation({
    mutationFn: handleLandingPageOptionsUpdate,
    mutationKey: ["refetchTableData"],
  });

  return (
    <SetupsDashboardNavHeaderContainer>
      {setupDescription && (
        <SetupDescriptionContent>
          <Content type={CONTENT_TYPES.BUTTON}>{setupDescription}</Content>
        </SetupDescriptionContent>
      )}
      <DynamicIdSelector
        handleLandingPageOptionsUpdate={refetchTableDataWithUpdatedOptions}
      />
    </SetupsDashboardNavHeaderContainer>
  );
}
